// ─── STORAGE / ID HELPERS ─────────────────────────────────────────────────────
// Thin, safe wrappers around localStorage plus a short random id generator.
// All three are used app-wide.
export const load = (key, fallback) => {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch { return fallback; }
};
export const save = (key, val) => { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} };
export const uid = () => Math.random().toString(36).slice(2, 10);
